if ($.fn.dataTable) {
  const Api = $.fn.dataTable.Api;
  const Scroller = $.fn.dataTable.Scroller;

  Api.register("scroller.toPosition()", function (px, animate) {
    var ctx = this.context;

    if (ctx.length && ctx[0].oScroller) {
      ctx[0].oScroller._toPosition(px, animate);
    }
  });

  Api.register("row().scrollTo()", function (fixTop = false, animationTime = 500) {
    var that = this;

    if (typeof fixTop == "number") {
      animationTime = fixTop;
      fixTop = false;
    }

    this.iterator("row", function (ctx, rowIdx) {
      if (ctx.oScroller) {
        ctx.oScroller._showRow(rowIdx, animationTime);
        return;
      }

      let row = that.row(rowIdx);
      let $row = $(row.node());
      let $table = $(row.table().node());
      let $body = $table.closest(".dataTables_scrollBody");

      if ($row.length == 0) return;

      let { top } = row.offset();
      let bodyHeight = $body[0].clientHeight;

      let rowHeight =
        $row[0].getBoundingClientRect().height +
        ((row.child() && row.child()[0].getBoundingClientRect().height) || 0);

      if (top < 0 || fixTop) {
        $body.animate(
          {
            scrollTop: $body.scrollTop() + top,
          },
          animationTime
        );
      } else if (top + rowHeight > bodyHeight) {
        $body.animate(
          {
            scrollTop: $body.scrollTop() + (top + rowHeight - bodyHeight),
          },
          animationTime
        );
      }
    });
  });

  Scroller.prototype._parseHeight = function (cssHeight) {
    return $(this.dom.scroller).height();
  };

  Scroller.prototype._calcRowHeight = function () {
    var dt = this.s.dt;
    var origTable = dt.nTable;
    var nTable = origTable.cloneNode(false);
    var tbody = $("<tbody/>").appendTo(nTable);
    var dtClasses = dt.oClasses;

    // Different locations for classes in DT2
    var classes = DataTable.versionCheck("2")
      ? {
          container: dtClasses.container,
          scroller: dtClasses.scrolling.container,
          body: dtClasses.scrolling.body,
        }
      : {
          container: dtClasses.sWrapper,
          scroller: dtClasses.sScrollWrapper,
          body: dtClasses.sScrollBody,
        };

    var container = $(
      '<div class="' +
        classes.container +
        ' DTS"><div class="' +
        classes.scroller +
        '"><div class="' +
        classes.body +
        '"></div></div></div>'
    );

    // Want 3 rows in the sizing table so :first-child and :last-child
    // CSS styles don't come into play - take the size of the middle row
    $("tbody tr:lt(4)", origTable).clone().appendTo(tbody);
    var rowsCount = $("tr", tbody).length;

    if (rowsCount === 1) {
      tbody.prepend("<tr><td>&#160;</td></tr>");
      tbody.append("<tr><td>&#160;</td></tr>");
    } else {
      for (; rowsCount < 3; rowsCount++) {
        tbody.append("<tr><td>&#160;</td></tr>");
      }
    }

    $("div." + classes.body, container).append(nTable);

    // If initialised using `dom`, use the holding element as the insert point
    var insertEl = this.s.dt.nHolding || origTable.parentNode;

    if (!$(insertEl).is(":visible")) {
      insertEl = "body";
    }

    // Remove form element links as they might select over others (particularly radio and checkboxes)
    container.find("input").removeAttr("name");

    container.appendTo(insertEl);
    this.s.heights.row = $("tr", tbody).eq(1)[0].getBoundingClientRect().height;

    container.remove();
  };

  Scroller.prototype._toPosition = function (px, animate) {
    const that = this;

    if (animate === undefined || animate) {
      const animationTime = typeof animate === "number" ? animate : 250;

      this.s.ani = !!animate;
      $(this.dom.scroller).animate(
        {
          scrollTop: px,
        },
        animationTime,
        function () {
          // This needs to happen after the animation has completed and
          // the final scroll event fired
          setTimeout(function () {
            that.s.ani = false;
          }, animationTime);
        }
      );
    } else {
      $(this.dom.scroller).scrollTop(px);
    }
  };

  Scroller.prototype._showRow = function (row, animate) {
    const px = this.rowToPixels(row);
    const rowHeight = this.s.heights.row;

    const viewport = this.dom.scroller.clientHeight;
    const scrollTop = this.dom.scroller.scrollTop;

    if (px < scrollTop) {
      this._toPosition(px, animate);
    } else if (px + rowHeight > scrollTop + viewport) {
      this._toPosition(px - viewport + rowHeight, animate);
    }
  };
}
